import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import _invert from "lodash/invert";

var _partnerCommissionSta, _partnerCommissionSta2, _reportStatusName, _reportStatusColorMap;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.define-property.js";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export var REPORT_STATUS = {
  requested: 'requested',
  sent: 'sent',
  confirmed: 'confirmed',
  rejected: 'rejected',
  pending: 'pending'
};
export var PARTNER_COMMISSION_STATUS = {
  submitted: 'submitted',
  accepted: 'accepted'
};
export var partnerCommissionStatusName = (_partnerCommissionSta = {}, _defineProperty(_partnerCommissionSta, PARTNER_COMMISSION_STATUS.submitted, 'Отчетено'), _defineProperty(_partnerCommissionSta, PARTNER_COMMISSION_STATUS.accepted, 'Прието'), _partnerCommissionSta);
export var partnerCommissionStatusColorMap = (_partnerCommissionSta2 = {}, _defineProperty(_partnerCommissionSta2, PARTNER_COMMISSION_STATUS.pending, 'orange'), _defineProperty(_partnerCommissionSta2, PARTNER_COMMISSION_STATUS.submitted, 'info'), _defineProperty(_partnerCommissionSta2, PARTNER_COMMISSION_STATUS.accepted, 'success'), _partnerCommissionSta2);
export var reportStatusName = (_reportStatusName = {}, _defineProperty(_reportStatusName, REPORT_STATUS.requested, 'ПОИСКАН'), _defineProperty(_reportStatusName, REPORT_STATUS.sent, 'ИЗПРАТЕН'), _defineProperty(_reportStatusName, REPORT_STATUS.confirmed, 'ПОТВЪРДЕН'), _defineProperty(_reportStatusName, REPORT_STATUS.rejected, 'OТХВЪРЛЕН'), _defineProperty(_reportStatusName, REPORT_STATUS.pending, 'ЧАКА ПОТВЪРЖДЕНИЕ'), _reportStatusName);
export var reportStatusColorMap = (_reportStatusColorMap = {}, _defineProperty(_reportStatusColorMap, REPORT_STATUS.requested, 'orange'), _defineProperty(_reportStatusColorMap, REPORT_STATUS.sent, 'info'), _defineProperty(_reportStatusColorMap, REPORT_STATUS.confirmed, 'success'), _defineProperty(_reportStatusColorMap, REPORT_STATUS.rejected, 'error'), _reportStatusColorMap);
export var reportStatusNameSelect = Object.entries(_invert(reportStatusName)).map(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      label = _ref2[0],
      value = _ref2[1];

  return {
    label: label,
    value: value
  };
});